var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnreadStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03142 0.822147L1.62508 0.0505354C1.32205 -0.11585 0.968055 0.152722 1.02581 0.505034L1.29433 2.13989L0.156527 3.29789C-0.0887826 3.54726 0.0466072 3.98181 0.385247 4.03348L1.95772 4.2719L2.66089 5.75953C2.81239 6.08016 3.25006 6.08016 3.40156 5.75953L4.10473 4.2719L5.67724 4.03348C6.01588 3.98219 6.15127 3.54767 5.90602 3.29789L4.76818 2.13989L5.03671 0.505034C5.09446 0.15269 4.74043 -0.11585 4.43743 0.0505354L3.03142 0.822147Z",
    fill: "#FF761C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadStar);
export default __webpack_public_path__ + "static/media/unread-star.d627bc7f7f3984f8cb16458f09edfa53.svg";
export { ForwardRef as ReactComponent };